import { authTokenStorage } from '~/gateways/auth/authTokenStorage';
import { MagicUseCase } from '../magicUseCase';

export class IsLoggedInUseCase extends MagicUseCase {
  protected async runLogic(redirectUrl?: string) {
    const token = authTokenStorage.getAuthToken();
    this.getState().user.loginInfo.isLoggedIn = token ? true : false;
    if (this.getState().user.loginInfo.isLoggedIn) {
      if (!redirectUrl || !redirectUrl.startsWith('/')) {
        this.navigate('/tenants');
      } else {
        this.navigate(redirectUrl);
      }
    } else {
      this.navigate('/tenants/auth/signin');
    }
  }
}
